import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { NewBackArrowIconForEvents, LaunchIcon } from '../../utils/icons';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { ToolTipNew } from '../AdminTeamCreation/styles';
import { EventHeading, HeadingContainer } from '../MainEvents/OnDemandDetailsPage/style';
import { EventCard, FlexWrapper, NewChampionsCard, NewContentV2, NewVideoPlayer } from '../ChallengeCreationAdmin/styles';
import PropTypes from 'prop-types';
import { GetChallengesList } from '../../redux/constants/apiConstants';
import { fetchApi } from '../../utils/methods';
import Thumbnail from '../Thumbnail';
import { ImageUrl } from '../../utils/constants';
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { ChallengesContainer } from '../JourneyChallenge/styles';
import { NoData } from '../ChallengeDashboardV2/styles';


function LegacyChallengeCategoryTab(props) {
  const { history, allRoles } = props;

  const [WellnessChallengeList, setWellnessChallengeList] = useState([]);
  const [onHover, setOnHover] = useState(-1);
  const location = useLocation();
  let pillarId = parseInt(location.state?.categoryData?.pillar_id, 10);
  const categoryDescription = location.state?.categoryData?.category_name;
  const isSuperAdmin = allRoles?.some((role) => role.rid === 3);
  const isWellnessAdmin = allRoles?.some((role) => role.rid === 12);



  const onEnterMouse = (id) => {
    setOnHover(id);
  };

  const onLeaveMouse = () => {
    setOnHover(-1);
  };

  useEffect(() => {
    getWellnessChallengeList();
  }, []);

  const getWellnessChallengeList = async () => {
    let apiUrl = GetChallengesList + "/" + pillarId;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.success === "success") {
        setWellnessChallengeList(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const renderHeading = () => {
    const popover = (value) => (
      <Popover
        id="popover-basic"
        style={{
          width: "auto",
          padding: "9px 14px",
          background: "#FFFFFF",
          border: "1px solid #005c87",
          boxShadow: "0px 13px 28px rgba(0, 0, 0, 0.3)",
          borderRadius: "6px",
        }}
      >
        <div
          style={{
            fontFamily: "Rubik",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "20px",
            color: "#005c87",
            textAlign: "center",
          }}
        >
          {value}
        </div>
      </Popover>
    );

    return (
      <EventHeading style={{ height: "56px" }}>
        <ToolTipNew
          margin={"auto 0px auto 15px"}
          height="40px"
          width="40px"
        >
          <OverlayTrigger placement="bottom" overlay={popover("Back")}>
            <div
              className='toolTip'
              onClick={() => history.push({ pathname: '/challenges/categories', query: { isCategory: true } })}
              style={{ background: "none" }}
            >
              <NewBackArrowIconForEvents />
            </div>
          </OverlayTrigger>
        </ToolTipNew>

        <div className="title">{categoryDescription}</div>
      </EventHeading>
    );
  };

  return (
    <div>
      <ChallengesContainer>
        <HeadingContainer>{renderHeading()}</HeadingContainer>
        <FlexWrapper>
          {WellnessChallengeList?.length > 0 ? WellnessChallengeList.map((item, index) => (
            <NewChampionsCard key={index}>
              <EventCard
                isMarginBottom={"0px"}
                onMouseEnter={() => onEnterMouse(index)}
                onMouseLeave={() => onLeaveMouse()}
              >
                <NewVideoPlayer>
                  <Thumbnail
                    style={{ cursor: 'default' }}
                    src={`${ImageUrl}/${item?.image}`}
                    alt={'img'}
                  />
                </NewVideoPlayer>
                {onHover === index && !isSuperAdmin && !isWellnessAdmin &&
                  <div
                    className='educateImageBackground'
                    onClick={() => history.push({
                      pathname: '/company/challenges/launch-legacy-challenge',
                      state: {
                        category_Id: pillarId,
                        categoryDescription: categoryDescription,
                        challenge_id: item.id,
                      },
                    })}
                  >
                    <div className="getStarted">
                      {LaunchIcon("#FFFFFF")}
                      {"Launch challenge"}
                    </div>
                  </div>
                }
                <NewContentV2 newPadding={'newPadding'} style={{ minHeight: 'auto' }}>
                  <div className='firstContainer'>
                    <div className='name' title={item?.title}>
                      {item?.title}
                    </div>
                  </div>
                </NewContentV2>
              </EventCard>
            </NewChampionsCard>
          )) :
            <NoData isBackground={"transparent"}>No Data Found!</NoData>
          }
        </FlexWrapper>
      </ChallengesContainer>
    </div>
  );
}

LegacyChallengeCategoryTab.propTypes = {
  history: PropTypes.object,
  allRoles: PropTypes.array,
};

const mapStateToProps = (state) => ({
  allRoles: state.profileData.allRoles,
});

export default connect(mapStateToProps)(LegacyChallengeCategoryTab);
